import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppUpdateStore = defineStore('appUpdate', () => {
  const showUpdateSnackbar = ref(false)
  const updateAvailable = ref(false)
  const hasShownWarning = ref(false)

  const triggerUpdate = () => {
    updateAvailable.value = true
    showUpdateSnackbar.value = true
    console.warn('App update triggered - user may see loading errors if dismissed')
  }

  const dismissUpdate = () => {
    showUpdateSnackbar.value = false
    hasShownWarning.value = true
    // updateAvailable remains true so it can be re-triggered on errors
  }

  const confirmUpdate = () => {
    showUpdateSnackbar.value = false
    window.location.reload()
  }

  // Re-show the snackbar if loading errors occur after dismissal
  const showUpdateWarningIfDismissed = () => {
    if (updateAvailable.value && hasShownWarning.value) {
      showUpdateSnackbar.value = true
    }
  }

  return {
    showUpdateSnackbar,
    updateAvailable,
    hasShownWarning,
    triggerUpdate,
    dismissUpdate,
    confirmUpdate,
    showUpdateWarningIfDismissed
  }
})
